<ngx-loading [show]="loading"></ngx-loading>
<kendo-grid
  class="emr-kendo-grid"
  [data]="details"
  [pageable]="false"
  [sortable]="{
    allowUnsort: false,
    mode: 'single'
  }"
  #grid="kendoGrid"
>
  <kendo-grid-column field="patientName" title="Patient" [width]="160">
    <ng-template kendoGridHeaderTemplate let-column>
      {{ column.title }}
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
      <div class="text-truncate">{{ dataItem.patientName | titlecase }}</div>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="amount" title="Amount" format="{0:c}" [width]="130">
    <ng-template kendoGridHeaderTemplate let-column>
      {{ column.title }}
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
      {{ (dataItem.amount ? dataItem.amount : 0) | currency }}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="invoiceId" title="Invoice #" [width]="120">
    <ng-template kendoGridHeaderTemplate let-column>
      {{ column.title }}
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
      <button
        *ngIf="(mobileBreakpoint$ | async) === false"
        type="button"
        class="btn-clean px-0 text-left underline"
        (click)="navigateToPatientInvoice(dataItem.patientId, dataItem.invoiceId)"
      >
        {{ dataItem.invoiceId }}
      </button>
      <div *ngIf="mobileBreakpoint$ | async">{{ dataItem.invoiceId }}</div>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="invoiceDate" title="Date" [width]="120">
    <ng-template kendoGridHeaderTemplate let-column>
      {{ column.title }}
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
      {{ dataItem.invoiceDate | date : 'MM-dd HH:mm' }}
    </ng-template>
  </kendo-grid-column>
</kendo-grid>
